define([
	"dojo/_base/declare",
	"csi/_base/storage",
	"./FoodLabelItemTable"
], function(declare, storage, FoodLabelItemTable) {

	const STORAGE_KEY = "ProductSalesRegionURLS";

	return declare(FoodLabelItemTable, {

		// Boolean: override to use expandLevel on Custom View
		bSupportsExpandLevelOption: true,

		/**
		 * @override
		 * Set the store per selected SalesRegions
		 */
		onViewCreate: function() {
			this.set("activeProductSalesRegions", storage.get(STORAGE_KEY));

			this.watch("activeProductSalesRegions", function(name, oldValue, newValue) {
				storage.set(STORAGE_KEY, newValue);
			});

			this.inherited(arguments);
		}

	});
});